import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Form, Button, Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import {
  get_task_data,
  get_branch_dropDown_data,
  get_employee_data,
  RegisterTaskAssignment,
} from "../../services/employeeApi";
import { toast } from "react-toastify";
import { validateForm } from "../../middleware/validateProjectForm";
import { GetUserInfo, hasAccess } from "../../utils/permissionChecker";
const EmpTaskAssignmentForm = ({ parentID, onSubmitButton }) => {
  const { t } = useTranslation();
  let history = useHistory();
  const user = GetUserInfo();
  const [formerror, setFormError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const queryClient = useQueryClient();
  const registrationMutation = useMutation(async (newData) => {
    await RegisterTaskAssignment(newData);
    queryClient.invalidateQueries("getempTaskAssignment");
  });

  const [formData, setFormData] = useState({
    worker_id: "",
    task_id: "",
    team_id: "",
    remark: "",
    status: 1,
    start_date: "",
    end_date: "",
    created_by: "",
    updated_by: "",
  });

  const { data, isLoading, isError, error } = useQuery(
    ["task-assignment"],
    async () => {
      try {
        const branchData = await get_branch_dropDown_data();
        const taskData = await get_task_data();
        const employeeData = await get_employee_data();
        return { branchData, taskData, employeeData };
      } catch (error) {
        throw new Error(`Error fetching data: ${error.message}`);
      }
    }
  );

  const filteredEmployeeData = useMemo(() => {
    const employeeData = data?.employeeData || [];

    if (!Array.isArray(employeeData)) return [];

    if (user.accessRole === "administrator") return employeeData;

    if (user.accessRole === "manager") {
      return employeeData.filter(
        (emp) => emp.branch_id === user?.employee?.branch_id
      );
    }

    return employeeData.filter((emp) => emp.id === user?.employee?.id);
  }, [data]);
  const filteredBranchData = useMemo(() => {
    const branchData = data?.branchData || [];

    if (!Array.isArray(branchData)) return [];

    if (user.accessRole === "administrator") return branchData;

    if (user.accessRole === "manager") {
      return branchData.filter((br) => br.id === user?.employee?.branch_id);
    }
    return branchData.filter((br) => br.id === user?.employee?.branch_id);
  }, [data]);
  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <div>Error: {error.message}</div>;
  }
  const { taskData } = data;
  const handleRegistration = async (assignmentData) => {
    try {
      setIsSubmitting(true);
      await registrationMutation.mutateAsync(assignmentData);
      toast.success("Registration successful", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      toast.error(error.message, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const requiredFields = ["worker_id", "task_id", "team_id"];
    const isEmptyField = requiredFields.some((field) => !formData[field]);
    if (isEmptyField) {
      setFormError(true);
      return;
    }
    handleRegistration(formData);

    // const errors = validateForm(formData);
    // if (Object.keys(errors).length === 0) {
    //   handleRegistration(formData);
    // } else {
    //   setValidationErrors(errors);
    // }
  };

  const handleCloseModal = () => {
    onSubmitButton();
  };

  const handleInputChange = (e, fieldName) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <div className="col-md-12 mb-3">
          <Form.Label
            htmlFor="inputPosition"
            className="font-weight-bold text-muted"
          >
            {t("task_name")}
          </Form.Label>
          <select
            id="inputPosition"
            className="form-select form-control choicesjs"
            value={formData.task_id}
            onChange={(e) => handleInputChange(e, "task_id")}
          >
            <option value="" hidden disabled>
              Select Task
            </option>
            {taskData.map((data) => (
              <option key={data.id} value={data.id}>
                {data.job_title}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-12 mb-3">
          <Form.Label
            htmlFor="inputPosition"
            className="font-weight-bold text-muted"
          >
            {t("employee")}
          </Form.Label>
          <select
            id="inputPosition"
            className="form-select form-control choicesjs"
            value={formData.worker_id}
            onChange={(e) => handleInputChange(e, "worker_id")}
          >
            <option value="" hidden disabled>
              Select Employee
            </option>
            {filteredEmployeeData.map((data) => (
              <option key={data.id} value={data.id}>
                {data.first_name} {data.father_name}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-12 mb-3">
          <Form.Label
            htmlFor="inputPosition"
            className="font-weight-bold text-muted"
          >
            {t("branch")}
          </Form.Label>
          <select
            id="inputPosition"
            className="form-select form-control choicesjs"
            value={formData.team_id}
            onChange={(e) => handleInputChange(e, "team_id")}
          >
            <option value="" hidden disabled>
              Select Branch
            </option>
            {filteredBranchData.map((data) => (
              <option key={data.id} value={data.id}>
                {data.name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-12 mb-3">
          <Form.Label htmlFor="Text1" className="font-weight-bold text-muted ">
            {t("description")}
          </Form.Label>
          <Form.Control
            as="textarea"
            id="horizontalTextarea"
            rows="3"
            value={formData.remark}
            onChange={(e) => handleInputChange(e, "remark")}
            required
            placeholder="Enter description"
          ></Form.Control>

          {formerror ? (
            <p className="text-danger">
              Looks like something’s missing! Please make sure to complete all
              required fields before submitting your registration.
            </p>
          ) : (
            ""
          )}
        </div>
        <div className="d-flex mt-1">
          <div className="mb-1">
            <Button className="bt btn-secondary" onClick={handleCloseModal}>
              {t("cancel")}
            </Button>
          </div>
          <div className="col-md-6 mb-1">
            <Button
              className="bt btn-info"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <span>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span className="visually-hidden">Sending...</span>
                </span>
              ) : (
                t("register")
              )}
            </Button>
          </div>
        </div>
      </Form>
    </>
  );
};

export default EmpTaskAssignmentForm;
